import flow from 'lodash/flow';
import { TopUp as DefaultTopUp, TopUpAutoRegister } from './TopUp';
import { withPayState, withState } from './TopUp.state';

export const TopUpModal = flow(() => DefaultTopUp, withState, withPayState)();
export const TopUpAutoReg = flow(() => TopUpAutoRegister, withState)();
